import {OPAC_TAB, OPENING_OPAC_REQUEST_EVENT} from '../opac.directive';
var angular:angular.IAngularStatic =  require('angular');
import {Component,Inject,Input,Output, EventEmitter} from 'ng-metadata/core';
import { RequestServicesService } from './requestsService.service';
//your imports go here
import {RequestService} from './request.service';
import {OpacService} from '../opac.service';
import {PnxUtil} from '../../../../../nddUtils/pnxUtil.service';
import {UserSessionManagerService} from  '../../../../../security/userSessionManager.service';
import {ChangeTabEvent} from '../opac.directive';
import {IGeneralAlertMsg} from '../../../../../infra/widgets/alerts/alertMsg.interface';
import {PrimoResponse} from '../../../../../infra/dataStructures/PrimoResponses/doc.interfcae';
import {ConfigurationUtil} from "../../../../../nddUtils/configurationUtil.service";
import { ngrsEnabledAndRSLinkIsOnlyService } from '../../../../../infra/ngrsUtil';
import { filteredServices } from '../../../../../infra/ngrsUtil';
import { getDisplayLocationLevelInGetItSingleLocation } from '../../../../../appConfig/appConfigForward';

const filter = require('lodash/filter');
const _get = require('lodash/get');

@Component({
	selector: 'prm-request-services',
	templateUrl: 'components/search/fullView/getit/opac/request/request-services.html',
})
export class PrmRequestServices {

    @Input() private item: PrimoResponse.IDoc;
	@Output() private changeTabEvent: EventEmitter<ChangeTabEvent>= new EventEmitter();
    @Input() public memberInst:string;
    @Input() public locationServices;
    @Input() public enableLibraryLevelList:boolean = false;
    @Input() public noLogin: boolean;

    private _recordId;
    private _servicesAdditionalParams: Object;
    private _servicesListIsLoading: boolean;

    private _services;

    constructor(private requestServicesService : RequestServicesService,
                private opacService : OpacService,
                private requestService : RequestService,
                private pnxUtil : PnxUtil,
                private userSessionManagerService : UserSessionManagerService,
                private configurationUtil: ConfigurationUtil,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$rootScope') private $rootScope: ng.IRootScopeService) {
    }

    /* getters / setters */
    get services() {
        if(this.locationServices){
            return this.locationServices;
        }else{
            return this._services;
        }
    }

    set services(services) {
        this._services = services;
    }

    get recordId() {
        return this._recordId;
    }

    set recordId(recordId) {
        this._recordId = recordId;
    }

    get form() {
        return this.requestService.form;
    }

    get tabId(){
        if (this.item.delivery.holding.length == 1 && !this.isRelatedItem(this.item.delivery.holding[0]) && !getDisplayLocationLevelInGetItSingleLocation()) {
            return OPAC_TAB.ITEMS;
        }else if (this.enableLibraryLevelList) {
            return OPAC_TAB.LIBRARIES;
        } else {
            return OPAC_TAB.LOCATIONS;
        }
    }

    get envURL(){
        return this.memberInst ? _get(this.item, 'delivery.almaInstitutionsList[0].envURL', '') : '';
    }

    private isRelatedItem(loc) {
        return !!loc.relatedTitle;
    }

    get servicesListIsLoading() {
        return this._servicesListIsLoading;
    }

    set servicesListIsLoading(servicesListIsLoading) {
        this._servicesListIsLoading = servicesListIsLoading;
    }

    /* public functions */
    public ngOnInit(){
        //setup
        this.activate();
        this._servicesAdditionalParams= this.requestService.getServicesAdditionalParams(this.item);
        this.$rootScope.$on('silentLogin',  ()=>this.reloadServices());
    }

    public getServiceAdditionalParams(service){
        return this._servicesAdditionalParams[service.type];
    }

    public isLoggedIn() {
        return !this.userSessionManagerService.isGuest();
    }

    private isLoggedInIDP() {
       return this.userSessionManagerService.isLoggedInIDP();
    }

    public changeTab($event){
        if ($event.dest === OPAC_TAB.REQUEST){
            this.$rootScope.$broadcast(OPENING_OPAC_REQUEST_EVENT, this.memberInst)
           }
		this.changeTabEvent.emit($event);
	}

    /* private functions */

    private reloadServices(){
        this.activate();
        this._servicesAdditionalParams= this.requestService.getServicesAdditionalParams(this.item);
    }

    private activate() {
        this.recordId = this.ripIlsApiId(this.item);
        this.requestService.ilsApiId = this.recordId;
        this.getServicesFromIls();
    }

    private getServicesFromIls() {

        /* reset services list */
        this.services = {};
        this.servicesListIsLoading = false;


        this.requestService.setMessages(this.requestService.getHtml(this.isLoggedIn(),undefined));

        if(this.configurationUtil.isSuprima() || this.isLoggedIn()) {
            this.servicesListIsLoading = true;


			let inst4opac = this.item.delivery.GetIt1
				.map( getit => getit.links)
				.reduce( (prev, cur) => prev.concat( cur ), [] )
				.filter(link => link.inst4opac )
				.map( link => link.inst4opac )[0];


            let isValidUser = this.checkValidUser(inst4opac,this.item.delivery.holding);
            if (this.item.delivery.GetIt1 && isValidUser) {
            /* read the new services list */
                let recInst = inst4opac || this.item.delivery.holding[0].organization;
                let physicalServiceId;
                if(this.item.delivery){
                    physicalServiceId = this.item.delivery.physicalServiceId;
                }
    	        this.opacService.getIlsServicesList(this.recordId, recInst, _get(this.item, 'delivery.hideResourceSharing', false), physicalServiceId, true, _get(this.item, 'delivery.almaInstitutionsList[0].envURL', ''))
    	            .then((res) => {
                        this.services = res.data;
    	                this.updateServicesList();

    					let message = res['reply-text'];
                        let noReqToDisplay:boolean = (!res.data.serviceinfo ||
													res.data.serviceinfo.length === 0 ||
													res.data.serviceinfo[0].allowed === 'N');
                    	if (this.isLoggedIn() && message && res['reply-code'] !== '0000' && noReqToDisplay) {
                        	this.requestService.setMessages(this.requestService.getHtml(this.isLoggedIn(), message));
                    	}

                        this.servicesListIsLoading = false;
    	           },
                   (error) => {
                       this.servicesListIsLoading = false;
                   });
            } else {
                this.requestService.setMessages(this.requestService.getHtml(this.isLoggedIn(), 'requesttab.user.not.valid'));
                this.servicesListIsLoading = false;
            }
       }
    }

    private checkValidUser(inst4opac,holding) {
        let instValue = inst4opac;
        let isValid = true;
        let hold = holding || [];
        hold.forEach((holdingItem,index,array) => {
            if(inst4opac === holdingItem.organization) {
                instValue = inst4opac;
                isValid = holdingItem.isValidUser;
            }
        });
        return instValue && isValid;
    }
     private updateServicesList() {
        angular.forEach(this.services.serviceinfo, (value, key) => {
            let service = {
               'path': value['link-to-service'],
               'method': 'GET',
               'serviceType': value['service-type']
           };
            this.opacService.updateService(value.type, service);
        });
    }

    private ripIlsApiId(item) {
        if (!item.delivery || !item.delivery.GetIt1) {
            return;
        }
        let ilsApiIds = filter(item.delivery.GetIt1, (cur) => {
            if (cur.category === 'Physical Item' || cur.category === 'Microform' || cur.category === 'Alma-P') {
                let links = cur.links;
                if (!links) {
                    return false;
                }
                let ilsApiIdsLink = filter(links, (link) => {
                    return link.ilsApiId;
                });

                return ilsApiIdsLink;
            }

         });

        return _get(ilsApiIds[0],'links[0].ilsApiId');
    }

    get reqAlert() :IGeneralAlertMsg {
    	//temp fix in order to make the sign-in component to disappear after logged in in service page
    	if(this.isLoggedIn() && this.requestService.reqAlert &&
			this.requestService.reqAlert.getMsgHtml() === this.requestService.getHtml(false,undefined)
		){
    		this.requestService.setMessages(this.requestService.getHtml(this.isLoggedIn(),undefined));
    	}
        return this.requestService.reqAlert;
    }

    public filteredServices(){
        return filteredServices(this.services.serviceinfo);
    }

    public ngrsEnabledAndRSLinkIsOnlyService(){
        return ngrsEnabledAndRSLinkIsOnlyService(this.services.serviceinfo);
    }

    get isRapidoSAEnabled(){
        return this.configurationUtil.getRapidoSAEnabled()
    }
    public isPartialAlma() {
        return this.configurationUtil.isPartialAlma();
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestServices.directive.ts